import React, { useRef } from 'react';
import { motion, useInView, useReducedMotion } from 'framer-motion';

/** Horizontal skill / signal bars for a hacker-style infographic. */
export default function SignalBars({ items = [], className = '' }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: '-60px' });
  const prefersReducedMotion = useReducedMotion();

  return (
    <ul ref={ref} className={`space-y-4 ${className}`}>
      {items.map((item, index) => (
        <li key={item.label}>
          <div className="mb-1.5 flex items-baseline justify-between gap-3">
            <span className="font-mono text-[12px] text-slate-700 dark:text-slate-300">
              <span className="text-emerald-500">$</span> {item.label}
            </span>
            <span className="font-mono text-[11px] text-slate-400">{item.value}%</span>
          </div>
          <div className="h-1.5 overflow-hidden rounded-full bg-slate-200/80 dark:bg-white/[0.06]">
            <motion.div
              className="h-full origin-left rounded-full bg-gradient-to-r from-blue-500 via-cyan-400 to-emerald-400"
              initial={{ scaleX: 0 }}
              animate={{ scaleX: inView || prefersReducedMotion ? item.value / 100 : 0 }}
              transition={{
                duration: prefersReducedMotion ? 0 : 1.1,
                delay: prefersReducedMotion ? 0 : index * 0.08,
                ease: [0.22, 1, 0.36, 1]
              }}
            />
          </div>
        </li>
      ))}
    </ul>
  );
}
